import HttpRequest from "@/api/axios";

const axios = new HttpRequest(process.env.VUE_APP_API_BASE_URL);

export default {
    getlist(data) {
        return axios.request({
            url: "match/e-list",
            method: "get",
            params:data
        });
    },
    getPlatelist(data) {
        return axios.request({
            url: "match-plate/list",
            method: "get",
            params:data
        });
    },
    getProlist(data) {
        return axios.request({
            url: "match-project/list",
            method: "get",
            params:data
        });
    },
    getMatchdetail(data) {
        return axios.request({
            url: "match/detail",
            method: "get",
            params:data
        });
    },
    editEnv(data) {
        return axios.request({
            url: "match-evaluation/edit",
            method: "post",
            data
        });
    },
    editEnvState(data) {
        return axios.request({
            url: "match-evaluation/upstate",
            method: "post",
            data
        });
    },
    getEnv(data) {
        return axios.request({
            url: "match-evaluation/detail",
            method: "get",
            params:data
        });
    },
    getEnvList(data) {
        return axios.request({
            url: "match-evaluation/list",
            method: "get",
            params:data
        });
    },
    getEnvDetail(data) {
        return axios.request({
            url: "match-evaluation/detail",
            method: "get",
            params:data
        });
    },
    getPlist(data) {
        return axios.request({
            url: "match-evaluation/plist",
            method: "get",
            params:data
        });
    },
}